import {
  Card,
  Stack,
  Title,
  Text,
  Box,
  Image,
  useMantineTheme,
} from "@mantine/core";
import { IconCheck } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

export default function SuccessPage({
  eventLogo,
  eventName,
  successMessage,
  additionalInfo,
}) {
  const { t } = useTranslation();
  const theme = useMantineTheme();
  const accentColor = theme.colors.accent?.[6] ?? theme.colors.blue[6];

  return (
    <Card shadow="sm" p="xl" radius="md" withBorder>
      <Stack gap="xl" align="center" style={{ textAlign: "center" }}>
        {eventLogo && (
          <Box>
            <Image src={eventLogo} alt="Event Logo" w={150} h={150} />
          </Box>
        )}

        <Box
          style={{
            backgroundColor: accentColor,
            borderRadius: "50%",
            width: "48px",
            height: "48px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <IconCheck size={20} color="white" stroke={3} />
        </Box>

        <Title order={2} style={{ fontSize: "28px", fontWeight: 700 }}>
          {eventName
            ? `${t("registration_thanks")} ${eventName}!`
            : t("registration_successful")}
        </Title>

        <Text size="md" style={{ maxWidth: "600px", lineHeight: 1.6 }}>
          {successMessage || t("registration_success_message")}
        </Text>

        {additionalInfo && (
          <Text
            size="sm"
            c="dimmed"
            style={{ maxWidth: "600px", lineHeight: 1.6 }}
          >
            {additionalInfo}
          </Text>
        )}
      </Stack>
    </Card>
  );
}
